import { render, staticRenderFns } from "./RefineActivityList.vue?vue&type=template&id=52a9a9fa"
import script from "./RefineActivityList.vue?vue&type=script&lang=js"
export * from "./RefineActivityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports